import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1c669550")

_pushScopeId("data-v-1c669550")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page__body" }
const _hoisted_3 = { class: "page__container" }
const _hoisted_4 = { class: "schedule__group" }
const _hoisted_5 = { class: "schedule__group" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheScheduleTable = _resolveComponent("TheScheduleTable")
  const _component_TheScheduleUpdate = _resolveComponent("TheScheduleUpdate")
  const _component_TheTimeslotTable = _resolveComponent("TheTimeslotTable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: ["table__wrapper", {'table__wrapper--collapsed': _ctx.collapsedCancelledGame}]
        }, [
          _createVNode("div", {
            class: "table__title",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleCancelledGameTable && _ctx.toggleCancelledGameTable(...args)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.matchesSectionTitle) + " ", 1),
            _createVNode("i", {
              class: {
                            'icon-angle-down': !_ctx.collapsedCancelledGame,
                            'icon-angle-right': _ctx.collapsedCancelledGame
                            }
            }, null, 2)
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_TheScheduleTable, {
              isEditable: false,
              filterSetName: _ctx.filterSetName
            }, null, 8, ["filterSetName"])
          ])
        ], 2),
        _createVNode("div", {
          class: ["table__wrapper", {'table__wrapper--collapsed': _ctx.collapsedTimeslots}]
        }, [
          _createVNode("div", {
            class: "table__title",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleTimeslotTable && _ctx.toggleTimeslotTable(...args)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.pendingSectionTitle) + " ", 1),
            _createVNode("i", {
              class: {
                            'icon-angle-down': !_ctx.collapsedTimeslots,
                            'icon-angle-right': _ctx.collapsedTimeslots
                            }
            }, null, 2)
          ]),
          _createVNode("div", _hoisted_5, [
            (_ctx.canUpdateTimeslots)
              ? (_openBlock(), _createBlock(_component_TheScheduleUpdate, {
                  key: 0,
                  matchUpdate: false,
                  fileImport: false
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_TheTimeslotTable, { filterSetName: _ctx.filterSetName }, null, 8, ["filterSetName"])
          ])
        ], 2)
      ])
    ])
  ]))
})